
export default function Footer() {
  return (
    <footer className="bg-black text-white py-6">
      <div className="max-w-7xl mx-auto px-8 text-center">
        <p className="text-sm text-gray-400">
          ©2025 Golden Tower. All rights reserved | Crafted by Berkon Group
        </p>
      </div>
    </footer>
  );
}
